import { Component, Input, OnChanges } from '@angular/core';
import {
	faClock,
	faHandHoldingMedical,
	faHashtag,
	faIndustry,
	faUtensils,
} from '@fortawesome/free-solid-svg-icons';

import { displayDate, getCaloricDensityTextForFeedObject, getCaloricDensityTextProduct } from 'src/app/app.util';
import { MilkProductDetails } from 'src/app/components/milk-details/milk-details.model';
import { MilkBankProductModel } from 'src/app/models/milk-bank-product.model';
import { SelectedProductIngredient } from 'src/app/models/prep-feed.model';
@Component({
	selector: 'app-product-details',
	templateUrl: './product-details.component.html',
	styleUrls: ['./product-details.component.scss'],
})
export class ProductDetailsComponent implements OnChanges {
	@Input() ingredient!: SelectedProductIngredient;
	@Input() hideExpiration = false;

	details: MilkProductDetails[] = [];

	ngOnChanges(): void {
		this.details = this.buildDetails();
	}

	private buildDetails(): MilkProductDetails[] {
		const receivedProduct = this.getReceivedProductScan();
		const product = this.ingredient?.product;

		const details: MilkProductDetails[] = [];

		if (!this.hideExpiration) {
			details.push({
				label: 'Expiration',
				icon: faClock,
				values: [
					this.displayDateValue(
						this.ingredient?.expirationDate ?? receivedProduct?.expirationDate,
					),
				],
			});
		}

		details.push(
			{
				label: 'Received',
				icon: faHandHoldingMedical,
				values: [this.displayDateValue(receivedProduct?.receivedDate)],
			},
			{
				label: 'Caloric Density',
				icon: faUtensils,
				values: [receivedProduct ? getCaloricDensityTextForFeedObject(receivedProduct) : product ? getCaloricDensityTextProduct(product) : '--'],
			},
			{
				label: 'Lot Number',
				icon: faHashtag,
				values: [this.displayValue(receivedProduct?.lotNumber)],
			},
			{
				label: 'Manufacturer',
				icon: faIndustry,
				values: [
					this.displayValue(
						receivedProduct?.productManufacturer ??
							(product as any)?.productManufacturer,
					),
				],
			},
		);

		return details;
	}

	private getReceivedProductScan(): MilkBankProductModel | undefined {
		return this.ingredient?.matchedScans?.[0] as
			| MilkBankProductModel
			| undefined;
	}

	private displayDateValue(value: unknown): string {
		return value ? displayDate(value as any) : '--';
	}

	private displayValue(value: unknown): string {
		if (value === null || value === undefined || value === '') {
			return '--';
		}

		return String(value);
	}
}
